import React from "react";
import { Row, Col, Card } from "antd";

const Dashboard = () => {
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col xs={12} md={6}>
                    <Card title="Gains totaux">120 000 FCFA</Card>
                </Col>
                <Col xs={12} md={6}>
                    <Card title="Produits vendus">45</Card>
                </Col>
                <Col xs={12} md={6}>
                    <Card title="Commandes">12</Card>
                </Col>
                <Col xs={12} md={6}>
                    <Card title="Activités">3</Card>
                </Col>
            </Row>

            <Card title="Activités récentes" style={{ marginTop: 20 }}>
                <p>✔ Vente de maïs effectuée</p>
                <p>✔ Achat de semences</p>
            </Card>
        </>
    );
};

export default Dashboard;